import styles from "../../../styles/Components/pricing-plan/individual-services/CreditBox.module.css";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { Modal } from "antd";
import { currencyFormatter } from "../../../utility/helper";
import React, { useState } from "react";
import ChargeCredit from "../ChargeCredit";
import SummaryBox from "./SummaryBox";
import CartIcon from "../../../ui/icons/CartIcon";

function CreditBox() {
  const {
    profile: { profileData, loading },
  } = useSelector((state) => state);
  const [showChargeCreditModal, setShowChargeCreditModal] = useState(false);

  return (
    <>
      <SummaryBox
        loading={loading}
        icon={<CartIcon />}
        title="Account Credit"
        value={`$${currencyFormatter(profileData?.credit / 100)}`}
      >
        <div
          className={styles.addBtn}
          onClick={() => setShowChargeCreditModal(true)}
        >
          <div className={styles.boxBtn}>
            <FaPlus size={12} />
          </div>
          <span>Add Credit</span>
        </div>
      </SummaryBox>

      {showChargeCreditModal && (
        <Modal
          open={showChargeCreditModal}
          onCancel={() => setShowChargeCreditModal(false)}
          footer={null}
          centered
        >
          <ChargeCredit />
        </Modal>
      )}
    </>
  );
}

export default CreditBox;
